import React from 'react';
import { AlertCircle } from 'lucide-react';

export const ErrorMessage = ({ message, onRetry }) => (
    <div className="flex flex-col justify-center items-center p-10 bg-red-50 rounded-lg text-center">
       <AlertCircle className="text-red-500" size={40} />
       <div className="ml-4 mt-4">
           <h4 className="font-bold text-red-700">Đã xảy ra lỗi</h4>
           <p className="text-sm text-red-600 max-w-md">{message}</p>
       </div>
       <button onClick={onRetry} className="mt-6 py-2 px-5 bg-blue-600 text-white rounded-lg hover:bg-blue-700">Thử lại</button>
   </div>
);